// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3cQRz","validationTips":"StatementDescriptor_validationTips__1vCTK"};